import React from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './themedButton.module.css';

const ThemedButton = ({ children, compact }) => (
    <Box component="span" className={clsx(styles.button, compact && styles.compact)}>
        {children}
    </Box>
);

ThemedButton.propTypes = {
    children: PropTypes.node,
    compact: PropTypes.bool,
};

export default ThemedButton;
